export function scrollToAppTop() {
  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  const main = document.querySelector<HTMLElement>(".main-content");
  if (main) main.scrollTop = 0;
}

export function scrollToAppTopAfterRender() {
  scrollToAppTop();
  window.requestAnimationFrame(() => window.requestAnimationFrame(scrollToAppTop));
  window.setTimeout(scrollToAppTop, 80);
}
